import { useState } from "react"
import { Button } from "react-bootstrap"
import { useUploadNotes } from "@apis/accounts/useAccounts"
import { toast } from "sonner"
import { Loader2 } from "lucide-react"

const ManualUploadForm = () => {
  const [note, setNote] = useState("")
  const [accountIds, setAccountIds] = useState("")
  const [accountIdsArray, setAccountIdsArray] = useState<string[]>([])

  const { mutate, isPending } = useUploadNotes()

  const handleNoteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNote(e.target.value)
  }

  const handleAccountIdsChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    const value = e.target.value
    setAccountIds(value)
    setAccountIdsArray(value.split(/[^\d]/).filter((item) => /\d/.test(item)))
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    mutate(
      { note, account_ids: accountIdsArray },
      {
        onSuccess: () => {
          toast.success("Successfully added notes!")
          resetForm()
        },
        onError: (error) => toast.error(`Error adding notes! ${error}`),
      },
    )
  }

  const resetForm = () => {
    setNote("")
    setAccountIds("")
    setAccountIdsArray([])
  }

  return (
    <div className="border border-secondary shadow bg-white p-4 rounded mb-5">
      <h3 className="px-2">Manual Upload</h3>
      <form
        onSubmit={handleSubmit}
        className="d-flex flex-column align-items-start gap-3 p-2"
      >
        <div className="w-100">
          <label
            htmlFor="note-upload-note-input"
            className="font-weight-bold d-block"
          >
            Note
          </label>
          <textarea
            className="border border-dark w-75 p-3 border rounded resize-none overflow-hidden tw:field-sizing-content"
            rows={1}
            value={note}
            onChange={handleNoteChange}
          />
        </div>

        <div className="w-100">
          <label
            htmlFor="note-upload-account-ids-input"
            className="font-weight-bold d-block"
          >
            Account IDs (Separated by any non-numeric character)
          </label>
          <textarea
            className="border border-dark w-75 p-3 border rounded resize-none overflow-hidden tw:field-sizing-content"
            rows={1}
            value={accountIds}
            onChange={handleAccountIdsChange}
          />
        </div>

        <div className="mt-1 d-flex w-75 gap-3 align-items-center">
          <Button
            type="submit"
            className="w-25 btn btn primary"
            disabled={!note || !accountIds}
          >
            {isPending ? (
              <Loader2 className="animate-spin" />
            ) : (
              `Add ${accountIdsArray.length} Notes`
            )}
          </Button>
          <Button
            className="w-25 btn btn btn-warning"
            disabled={isPending}
            onClick={resetForm}
          >
            Reset Form
          </Button>
        </div>
      </form>
    </div>
  )
}

export default ManualUploadForm
